/* eslint-disable import/no-unresolved */
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
    useLazyQuery, useMutation, useQuery, useReactiveVar,
} from '@apollo/client';

import { CREATE_FFIEC009_USER_COMMENT, DELETE_FFIEC009_USER_COMMENT, UPDATE_FFIEC009_USER_COMMENT } from 'Apollo/Mutations/Rules/FFIEC009';
import { GET_USER_INFO } from 'Apollo/Queries';
import { GET_USER_COMMENTS_FOR_FFIEC009 } from 'Apollo/Queries/Rules/FFIEC009Results';
import { tenantIdVar } from 'Apollo/config';
import FFIEC009Comment from '../components/FFIEC009Comment';

const FFIEC009Comments = ({ refetch }) => {
    const location = useLocation();
    const [batchId, setBatchId] = useState(location.state.batchId);
    const [ruleId, setRuleId] = useState(location.state.ruleId);
    const [ffiec009Comment, setFFIEC009Comment] = useState('');
    const [ffiec009Show, setFFIEC009Show] = useState(false);
    const [ffiec009Target, setTarget] = useState(null);
    const [ffiec009Edit, setEdit] = useState(false);
    const [ffiec009SelectedComment, setFFIEC009SelectedComment] = useState('');
    const [ffiec009SelectedCommentID, setSelectedCommentID] = useState('');
    const [ffiec009SelectedIndex, setSelectedIndex] = useState(null);
    const tenantId = useReactiveVar(tenantIdVar);

    /* Apollo query to fetch user information */
    const getFFIEC009User = useQuery(GET_USER_INFO);

    /* Apollo lazy query to fetch all the comments  */
    const [getComments, { loading, data: { getUserCommentsForFFIEC009 = {} } = {} }] = useLazyQuery(GET_USER_COMMENTS_FOR_FFIEC009, {
        variables: {
            input: {
                batchId: parseInt(batchId, 10),
                ruleId: parseInt(ruleId, 10),
                tenantId: parseInt(tenantId, 10),
            },
        },
        fetchPolicy: 'no-cache',
    });

    /* Apollo mutation to add new comment  */
    const [addResultComment, { loading: commentLoading }] = useMutation(CREATE_FFIEC009_USER_COMMENT, {
        variables: {
            input: {
                batchId: parseInt(batchId, 10),
                ruleId: parseInt(ruleId, 10),
                tenantId: parseInt(tenantId, 10),
                commentText: ffiec009Comment,
            },
        },
    });

    /* Apollo mutation to delete a comment  */
    const [deleteComment] = useMutation(DELETE_FFIEC009_USER_COMMENT);

    /* Apollo mutation to update comment  */
    const [updateComment] = useMutation(UPDATE_FFIEC009_USER_COMMENT);

    /* Side effect when location state updates */
    useEffect(() => {
        setBatchId(location.state.batchId);
        setRuleId(location.state.ruleId);
    }, [location]);

    /* Comment option handler */
    const handleFFIC009Click = (index, text, commentId, event) => {
        setFFIEC009Show(!ffiec009Show);
        setSelectedIndex(index);
        setFFIEC009SelectedComment(text);
        setSelectedCommentID(commentId);
        setTarget(event.target);
    };

    /* Calls  addResultComment(), getComments() and refetch that failed tests result */
    const addFFIEC009Comment = async () => {
        await addResultComment();
        getComments();
        refetch();
        setFFIEC009Comment('');
    };

    /* Toggled edit value */
    const onFFIEC009EditClick = () => {
        setEdit(!ffiec009Edit);
    };

    /* Cancal button handler */
    const onFFIEC009CancelClick = () => {
        setEdit(!ffiec009Edit);
        setSelectedIndex(null);
        setFFIEC009SelectedComment('');
        setFFIEC009Show(!ffiec009Show);
    };

    /* Calls updateComment and refetch the failed tests resut */
    const onFFIEC009ClickSave = async () => {
        await updateComment({
            variables: {
                input: {
                    commentText: ffiec009SelectedComment,
                    commentId: ffiec009SelectedCommentID,
                    tenantId: parseInt(tenantId, 10),
                    batchId,
                    ruleId,
                },
            },
        });
        getComments();
        setEdit(!ffiec009Edit);
        setSelectedIndex(null);
        setFFIEC009SelectedComment('');
        setFFIEC009Show(!ffiec009Show);
        refetch();
    };

    /* Calls deleteComment and refetch the failed tests resut */
    const onFFIEC009ClickDelete = async () => {
        await deleteComment({
            variables: {
                input: {
                    commentId: ffiec009SelectedCommentID,
                    tenantId: parseInt(tenantId, 10),
                    batchId,
                    ruleId,
                },
            },
        });
        getComments();
        setSelectedIndex(null);
        setFFIEC009SelectedComment('');
        setFFIEC009Show(!ffiec009Show);
        refetch();
    };

    /* Side effect to fetch comments initially */
    useEffect(() => {
        getComments();
    }, []);

    return (
        <FFIEC009Comment
            getFFIEC009User={getFFIEC009User}
            ffiec009Comment={ffiec009Comment}
            setFFIEC009Comment={setFFIEC009Comment}
            commentLoading={commentLoading}
            addFFIEC009Comment={addFFIEC009Comment}
            loading={loading}
            getUserCommentsForFFIEC009={getUserCommentsForFFIEC009}
            handleFFIC009Click={handleFFIC009Click}
            onFFIEC009EditClick={onFFIEC009EditClick}
            onFFIEC009ClickDelete={onFFIEC009ClickDelete}
            onFFIEC009CancelClick={onFFIEC009CancelClick}
            onFFIEC009ClickSave={onFFIEC009ClickSave}
            ffiec009Show={ffiec009Show}
            ffiec009Target={ffiec009Target}
            ffiec009Edit={ffiec009Edit}
            ffiec009SelectedComment={ffiec009SelectedComment}
            ffiec009SelectedCommentID={ffiec009SelectedCommentID}
            setFFIEC009SelectedComment={setFFIEC009SelectedComment}
            ffiec009SelectedIndex={ffiec009SelectedIndex}
        />
    );
};

export default FFIEC009Comments;
